<template>
  <div
    class="left_menu left-big-screen"
    :style="needHidLeft1"
    @click="leftMenuClickEv"
  >
    <el-tabs @tab-click="tabClick" v-model="tabActiveName" class="left-menu-tabs">
      <el-tab-pane label="模块" name="first">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item
            v-for="(menu, index) in displayMenuSource"
            :title="menu.name"
            :key="index"
            :name="index + 1"
            v-if="!(menu.name === '布局' && !isLayout)"
          >
            <div :style="needHidLeft2">
              <div>
                <ul class="menu_item_content_ul" @click.stop>
                  <template v-if="menu.name === '收藏'">
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      :data-hhhh="menu"
                      v-for="(container_item, child_index) in menu.children"
                      draggable="true"
                      @dragstart="dragstartEv"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                      @mouseover="showDeleteIcon(child_index)"
                      @mouseout="hideDeleteIcon"
                    >
                      <img class="menu-icon" :src="collectIcon" alt="" />
                      <p>{{ container_item.title || container_item.name }}</p>
                      <span
                        v-show="showCollectDeleteIconIndex === child_index"
                        class="deleteCollect"
                        @mousedown.stop
                        @click.stop="delCollect(container_item)"
                        ><i class="icon icon-portal-delete"></i
                      ></span>
                    </li>
                  </template>
                  <template v-else-if="menu.name === '布局' && !isLayout">
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      v-for="(container_item, child_index) in menu.children[0].children"
                      draggable="true"
                      @dragstart="dragstartEv"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                    >
                      <img
                        class="menu-icon"
                        :src="container_item.attribute.options.thumbnail"
                        alt=""
                      />
                      <p>{{ container_item.attribute.options.styleName }}</p>
                    </li>
                  </template>
                  <template v-else>
                    <li
                      class="left_menu_title"
                      :key="child_index"
                      v-for="(container_item, child_index) in menu.children"
                      draggable="true"
                      @dragstart="dragstartEv"
                      @dragend="dragendEv"
                      @mousedown="elementMouseDown(container_item, menu.name, $event)"
                    >
                      <img
                        class="menu-icon"
                        :src="menuThumbnail(container_item)"
                        alt=""
                      />
                      <p>{{ container_item.name }}</p>
                    </li>
                  </template>
                </ul>
                <div v-if="menu.name === '收藏'" class="pagination">
                  <el-pagination
                    small
                    hide-on-single-page
                    layout="prev, pager, next"
                    :page-size="18"
                    @current-change="handleCurrentChange"
                    :total="menu.collectTotal"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane v-if="!isLayout" label="图层" name="third">
        <el-collapse v-model="layerActiveNames">
          <el-collapse-item v-if="checkLayoutStage" title="页面图层" name="1"><stageLayoutLayer /></el-collapse-item>
        </el-collapse>
        <el-collapse v-model="layerActiveNames">
          <el-collapse-item title="画布图层" name="2"><layer /></el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
    <!-- 保存画布模块对话框 -->
    <el-dialog
      title="模板的名称"
      :visible.sync="dialogFormVisible"
      :modal-append-to-body="false"
      custom-class="collectDialog"
    >
      <div>
        <el-input v-model="collectModuleForm.name" placeholder="请输入模板的名称"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="saveStageModuleEv">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable"
import close from "assets/images/close.png"
import stageLayoutLayer from "./stageLayoutLayer.vue"
import layer from "./layer.vue"
import collectIcon from "assets/images/leftMenu/collect.png"
import { deepChangeUid, encryption } from "utils"
import { data_dictionary_map } from "root/static/dataDictionary.js"
import instance from "../../../interceptor"
import { initModules, initStageModules, getFirstModuleEncId, getBigScreenCollect } from "@/utils/initEv.js"
import { primaryBigScreenGenerator as primarybigScreenGenerator } from "../../../store/modules/bigScreen/state"

import { _throttle, hasProperty } from "../../../utils"
import store from "../../../store"
import Qs from "qs"
const mockData = { primarybigScreenGenerator }

export default {
  name: "left-menu.vue",
  props: {
    menuSource: { type: Array, default: [] }
  },
  components: {
    layer,
    stageLayoutLayer,
    draggable
  },
  data() {
    return {
      tabActiveName: "first",
      layerActiveNames: ["2"],
      activeNames2: [],
      activeNames: [1, 2, 3, 4, 5],
      needHid: false,
      mouseOverDel: false,
      needHidLeft1: null,
      needHidLeft2: null,
      closeImage: close,
      collectIcon: collectIcon,
      nameControl: true,
      doAdd: false,
      dataSource: this.menuSource,
      scrollHeight: null,
      showCollectDeleteIconIndex: null,
      dialogFormVisible: false,
      collectModuleForm: {
        name: null,
        type: 100
      },
      delayTime: 1000
    }
  },
  created() {
  },
  mounted() {},
  computed: {
    displayMenuSource() {
      const params = {admin : this.GetRequestAdmin('admin')}
      const source = this.menuSource.map(item => {
        const _item = Object.assign({}, item, {children: []})
        _item.children = item.children.filter(sub_menu => {
          const enable = sub_menu.enable
          // 如果enable没有定义，则默认为显示，如果enable为函数则传入参数取值
          if (enable === undefined || enable === null) return true
          if (typeof enable === 'function') {
            return enable(params)
          }
          return enable
        }).sort((a, b) => (a.sort || 0) - (b.sort || 0))
        return _item
      })
      return source
    },
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    checkLayoutStage() {
      return this.$store.state[this.request_prefix].page?.layoutOption?.rows
    },
    stageSource() {
      return this.$store.state[this.request_prefix].page.children
    },
    showMenuTab() {
      return !this.isLayout ? true : false
    },
    menuPageList: {
      get() {
        return JSON.parse(JSON.stringify(this.stageSource))
      },
      set(val) {}
    },
    activeStageIndex() {
      for (let i = 0; i < this.menuPageList.length; i++) {
        if (this.menuPageList[i].isActive) {
          return i
        }
      }
      return 0
    },
    isShowContent() {
      return this.menuSource.map(item => item.isActive).indexOf(true)
    },
    ids() {
      return this.$store.state.states.activeID
    },
    menuThumbnail() {
      return function (containerItem) {
        return containerItem.thumbnail
          ? containerItem.thumbnail
          : containerItem.children && containerItem.children.length > 0
          ? containerItem.children[0].thumbnail
          : ""
      }
    }
  },

  methods: {
    handleCurrentChange(index) {
      getBigScreenCollect.call(this, index)
    },
    setMouseOver(name) {
      if (name === "页面设置" && this.isShowContent === -1) {
        this.nameControl = false
      }
    },
    mouseleave(name) {
      if (name === "页面设置" && this.isShowContent === -1) {
        this.nameControl = true
      }
    },
    // 控制menu选中时右侧文字宽度
    fixMenuCircleW() {
      this.$nextTick(() => {
        const rootDoc = document.getElementsByClassName("left_menu")[0]
        const tabs = rootDoc.getElementsByClassName("el-tabs__item is-left")
        for (let i = 0; i < tabs.length; i++) {
          if (tabs[i].offsetWidth !== 0) {
            tabs[i].style.width = tabs[i].innerText.length * 14 + 24 + "px"
          }
        }
      })
    },
    closeMenu(index) {
      this.$store.dispatch("menu/unsetActive", { id: index })
    },
    tabClick(tab) {
      this.$store.dispatch(this.request_prefix + "/changeStageLayoutOption", {
        key: "buttonContextUid",
        value: ""
      })
    },
    leftMenuClickEv() {
      if (this.$store.state.states.changeToolBarStatus) {
        this.$store.commit("states/changeToolBarStatus", false)
      }
      if (this.$store.state.states.changeAlignHelperStatus) {
        this.$store.commit("states/changeAlignHelperStatus", false)
      }
    },
    handleOpen($event, tempId) {
      // 获取当前元素
      const acId = this.$store.getters["menu/getActiveMenu"]
      // const index = $event ? Number($event.currentTarget.attributes["index"].nodeValue) : null,
      const index = $event ? Number($event.currentTarget.attributes["index"].nodeValue) : null
      // activeId = this.getActiveMenu()
      this.id = index !== null ? index : this.id
      if (tempId === acId) {
        this.$store.dispatch("menu/unsetActive", { id: tempId })
      } else {
        this.$store.dispatch("menu/setActive", { id: tempId == 321 ? tempId : this.id })
        this.fixMenuCircleW()
        this.nameControl = true
      }
    },
    getActiveMenu() {
      let len = this.$store.state.menu.menu.children.length,
        item = this.$store.state.menu.menu.children,
        result = null
      for (let i = 0; i < len; i++) {
        if (item[i].isActive) {
          result = i
          break
        }
      }
      return result
    },

    changeStageIndex(evt) {
      console.log(evt)
      this.$store.dispatch(
        this.request_prefix + "/changeContainerPosition",
        JSON.parse(
          JSON.stringify({
            type: "move",
            newIndex: evt.newIndex,
            oldIndex: evt.oldIndex
          })
        )
      )
    },
    addContainer(id) {
      let isAddSystemEndPage = this.$store.state[this.request_prefix].page.isAddSystemEndPage
      let lastContainerId = isAddSystemEndPage
        ? this.stageSource[this.stageSource.length - 2].container_id
        : this.stageSource[this.stageSource.length - 1].container_id
      let thisId = typeof id !== "number" ? lastContainerId : id
      const param = {
        container_data: new mockData["primary" + this.request_prefix + "Generator"](),
        id: thisId
      }
      this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
    },
    copyContainer(id, index) {
      let isAddSystemEndPage = this.$store.state[this.request_prefix].page.isAddSystemEndPage
      let lastContainerId = isAddSystemEndPage
        ? this.stageSource[this.stageSource.length - 2].container_id
        : this.stageSource[this.stageSource.length - 1].container_id
      let thisId = typeof id === "undefined" ? lastContainerId : id
      const param = {
        container_data: JSON.parse(JSON.stringify(this.stageSource[index])),
        id: thisId
      }
      this.$store.dispatch(this.request_prefix + "/insertContainer", JSON.parse(JSON.stringify(param)))
    },
    changeActiveStage(id, index) {
      // this.activeStageIndex = index
      // const acId = this.$store.getters["menu/getActiveMenu"]
      // // 选中当前容器
      // const acId = this.$store.getters["menu/getActiveMenu"]
      // 选中当前容器
      const _stage = this.$store.state[this.request_prefix]
      if (!this.getAttrById(_stage, { container_id: id }).isActive)
        this.$store.commit("states/changeActiveID", { container_id: id })
      this.$store.dispatch(this.request_prefix + "/setContainerActive", { container_id: id })
      this.$store.commit("states/changeElementType", "bigScreenContainer")
    },
    delMyContainer(id) {
      // 删除画布
      const _stage = this.$store.state[this.request_prefix]
      if (this.getAttrById(_stage, { container_id: id }).isActive) this.$store.commit("states/changeActiveID", null)
      this.$store.dispatch(this.request_prefix + "/deleteContainer", id)
    },
    async dragstartEv(e) {
      const _self = this
      this.$store.commit("states/changeLeftMenuDragStatu", true)
      //
      sessionStorage.setItem("isDragging", true)
      e.dataTransfer.setData("rectAttribute", JSON.stringify(this.rectAttr))
      //  考虑布局拖入页面的交互效果差异   e.dataTransfer 在dragover事件中获取为空
      if (this.rectAttr?.shape === "cxPageLayout") {
        localStorage.setItem("dragType", "cxPageLayout")
      }
      setImmediate(() => {
        _self.showStatus = false
      })
    },
    dragendEv() {
      this.showStatus = true
      sessionStorage.removeItem("isDragging")
      sessionStorage.removeItem("dropOverCell")
      localStorage.removeItem("dragType")
      this.$store.commit("states/changeLeftMenuDragStatu", false)
    },
    //鼠标按下
    elementMouseDown(childItem, childTypeName, e) {
      let type, attribute
      // 系统样式 需要调用样式列表接口
      let childItemInfo = {
        childItemTypeId: childItem.typeId,
        childItemTypeName: childItem.type,
        childItemName: childTypeName === "收藏" ? "收藏" : childItem.name
      }
      sessionStorage.setItem("childItemInfo", JSON.stringify(childItemInfo))
      if (childItem.children?.length === 0 && childItem.typeId) {
        this.rectAttr = undefined
        return
        // childItem = await getFirstModuleEncId.call(this,childItem.typeId)
        // type = childItem.content.shape
        // attribute = childItem.content
      } else {
        if (childTypeName === "布局" || childTypeName === "cxPageLayout") {
          type = childItem.attribute.shape
          attribute = childItem.attribute
        } else if (childTypeName === "收藏") {
          // type = childItem.content.shape
          // attribute =  childItem.content
          this.rectAttr = childItem
          return
        } else {
          type = childItem.children[0].attribute.shape
          attribute = childItem.children[0].attribute
        }
      }
      const _attribute = JSON.parse(JSON.stringify(attribute))

      this.resetRectAttrOpt(childItem, _attribute)
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      // this.doAdd = true
      //鼠标移动处理
      if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      this.rectAttr = _attribute
    },
    computedTextStyle(style) {
      return {
        lineHeight: `${style.lineHeight}px`,
        fontSize: `${style.fontSize}px`,
        backgroundColor: style.bgColor,
        color: style.color,
        fontWeight: style.fontWeight
      }
    },
    computedButtonStyle(style) {
      return {
        lineHeight: `${style.height}px`,
        width: `${style.width}px`,
        fontSize: `${style.fontSize}px`,
        borderRadius: `${style.hoverBorderBottomRightRadius}px`,
        backgroundColor: style.bgColor,
        color: style.color,
        border: `${style.borderWidth}px ${style.borderStyle} ${style.borderColor}`,
        boxShadow: `${style.boxShadowH}px ${style.boxShadowV}px  ${style.boxShadowBlur}px  ${style.boxShadowSpread}px ${style.boxShadowColor}`
      }
    },
    handleChange() {},
    GetRequestAdmin(label) {
      var url = location.href //获取url中"?"符后的字串
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1]
        var strs = str.split("&")
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1])
        }
      }
      let val = theRequest[label]
      return val
    },
    showDeleteIcon(index) {
      this.showCollectDeleteIconIndex = index
    },
    hideDeleteIcon() {
      this.showCollectDeleteIconIndex = null
    },
    delCollect(param) {
      const self = this
      if (param.encId) {
        instance
          .post(`v2/${param.encId}/remove`)
          .then(() => {
            initModules.call(self)
          })
          .catch(err => {})
      }
    },
    // 设为模板
    handleParam(encAppId) {
      const _ids = this.ids
      let content = JSON.parse(
        JSON.stringify(
          this.$store.state[this.request_prefix].page.children.find((val, index, arr) => {
            if (val.container_id === _ids.container_id) {
              return val
            }
          })
        )
      )
      content.isActive = false
      content.container_id = undefined
      content = encryption(content, data_dictionary_map)
      const param = {
        c: content,
        a: encAppId
      }
      return param
    },
    saveStageModuleEv() {
      if (this.collectModuleForm.name !== null) {
        const { pageId, wfwfid } = this.$store.state.states.getDataPageIds
        const _self = this
        const params = {
          a: "7C5C8F204A2F4171",
          w: wfwfid,
          p: pageId,
          t2: "20106053E31351DC",
          t: _self.collectModuleForm.name
        }
        this.$API
          .createComponentApp({
            param: params
          })
          .then(res => {
            if (res.data.data.moduleId) {
              initStageModules.call(_self)
              _self.collectModuleForm.name = null
              _self.collectModuleForm.type = null
              _self.$message({
                customClass: "bigScreen_msg_backGroud",
                duration: 3000,
                type: "success",
                message: "保存成功"
              })
              _self.dialogFormVisible = false
              // _self.updateMenu();
            }
          })
          .catch(err => {})
      } else {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "您输入的数据不正确，请检查内容",
          type: "error"
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.left-menu-tabs {
  height: 100%;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent;
}
::v-deep.left-menu-tabs .el-tabs__header {
  margin: 0;
}
::v-deep.left-menu-tabs .el-tabs__nav {
  display: flex;
  //width: calc(100% - 24px);
  width: 100%;
}
::v-deep .left-menu-tabs .el-tabs__item {
  flex: 1;
  text-align: center;
  padding: 0;
  line-height: 48px;
  height: 48px;
  font-size: 16px;
}
::v-deep .left-menu-tabs .el-tabs__item.is-active {
  color: var(--themeColor);
}
::v-deep .left-big-screen .left-menu-tabs .el-tabs__item.is-active {
  background: radial-gradient(48.33% 68.18% at 51.67% 100%, rgba(0, 98, 255, 0.24) 0%, rgba(31, 36, 45, 0) 100%);
}
::v-deep .left-menu-tabs .el-tabs__item.is-active:after {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  height: 2px;
  width: 100%;
  content: "";
  max-width: 150px;
  transform: translateX(-50%);
  background: linear-gradient(
    90deg,
    rgba(196, 196, 196, 0.27125) 0%,
    rgba(23, 112, 255, 0) 0%,
    var(--themeColor) 50%,
    rgba(23, 112, 255, 0) 100%
  );
}
::v-deep .left-menu-tabs .el-tabs__active-bar {
  background-color: var(--themeColor);
}
::v-deep.left-menu-tabs .el-tabs__active-bar {
  width: 33.3% !important;
}
.left_menu {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 48px);
  overflow-y: auto;
  width: calc(100% + 18px);
  box-sizing: border-box;
}

/*::v-deep .el-collapse-item__header,*/
/*::v-deep .el-collapse-item__wrap {*/
/*  background-color: transparent;*/
/*  color: rgba(255, 255, 255, 0.8);*/
/*}*/
::v-deep .el-collapse-item__content {
  /*color: rgba(255, 255, 255, 0.8);*/
  font-size: 14px;
  padding-bottom: 0;
}
::v-deep .el-collapse-item__header,
::v-deep .el-collapse {
  border: none;
}
::v-deep .el-collapse,
::v-deep .el-collapse-item,
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}

::v-deep .el-collapse-item:last-child {
  margin-bottom: 36px;
}
.menu_item_content_ul {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 0 0 12px 15px;
  > li {
    width: 68px;
    box-sizing: border-box;
    margin: 16px 1px 4px;
    padding: 3px 0 7px 0;
    cursor: grab;
    text-align: center;
    border: 1px solid transparent;
    position: relative;
    font-size: 13px;
    &:hover {
      border: 1px solid var(--themeColorIcon);
      border-radius: 4px;
      p {
        font-weight: 600;
      }
    }
    &:active {
      cursor: grabbing;
    }
    p {
      line-height: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: 4px;
      font-size: 12px;
    }
    .menu-icon {
      display: inline-block;
      width: 32px;
      height: 32px;
      font-size: 32px;
      margin: 0 auto;
      color: var(--themeColorIcon);
    }
    .deleteCollect {
      position: absolute;
      top: -20px;
      right: 0;
      cursor: pointer;
    }
  }
}
::v-deep .el-collapse-item__header {
  padding: 0 24px;
  box-sizing: border-box;
  height: 44px;
  line-height: 44px;
}
.left-big-screen {
  ::v-deep .el-collapse-item__header {
    padding: 0 12px 0 30px;
    height: 34px;
    line-height: 34px;
  }
  .left-menu-tabs ::v-deep .el-collapse-item__arrow {
    transform: rotate(0);
    color: var(--thirdTextColor);
    position: absolute;
    left: 12px;
  }
  .left-menu-tabs ::v-deep .el-collapse-item__arrow::before {
    content: "\e791";
  }
  .left-menu-tabs ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(90deg);
  }
}
::v-deep.left_menu > .el-collapse {
  padding-bottom: 50px;
}
.left-big-screen .left-menu-tabs ::v-deep .el-tabs__active-bar {
  height: 0;
}
#addPhonePage {
  width: 208px;
  border: 1px solid;
  color: var(--themeColor);
  line-height: 30px;
  border-radius: 4px;
  text-align: center;
  margin: 16px auto;
  cursor: pointer;
  .icon {
    display: inline-block;
    margin-right: 2px;
  }
  &:hover {
    background: var(--themeColorSelectBg);
  }
}
.leftPagelist {
  > li {
    position: relative;
    text-align: center;
    padding: 8px 12px 12px;
    box-sizing: border-box;
    cursor: pointer;
    .add-new-stage {
      position: absolute;
      display: none;
      left: 50%;
      bottom: 2px;
      font-size: 12px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      margin-left: -10px;
      background-color: var(--themeColor);
      padding: 0;
      color: #fff;
    }
    .page-handles {
      visibility: hidden;
    }
    &:hover {
      color: var(--themeColor);
      .page-handles {
        visibility: visible;
      }
      .add-new-stage {
        display: block;
      }
      .scan-page {
        border: 1px solid var(--themeColor);
      }
    }
    .scan-page {
      width: 112px;
      height: 179px;
      border: 1px solid var(--borderColorFour);
    }
    &.active {
      background-color: var(--themeColorSelectBg);
      color: var(--themeColor);
      cursor: move;
      .scan-page {
        border: 1px solid var(--themeColor);
        box-shadow: 0 0 0 1px var(--themeColor);
      }
      .page-handles {
        visibility: visible;
      }
    }
    .icon {
      display: block;
      font-size: 16px;
      margin: 20px auto;
      color: var(--subTextColor);
      cursor: pointer;
      width: 28px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 4px;
      &:hover {
        background-color: var(--iconHoverBgColor);
      }
    }
  }
}
::v-deep.pagination .el-pagination {
  margin: 0 auto;
}
::v-deep.pagination .el-pagination .btn-next,
::v-deep.pagination .el-pagination .btn-prev {
  background-color: transparent;
  color: var(--text);
}
::v-deep.pagination .el-pager li {
  background-color: transparent;
  color: var(--text);
}
::v-deep.pagination .el-pager li.active {
  color: var(--themeColor);
}
</style>
<style>
.left-menu-tooltip.el-tooltip__popper {
  background: rgba(0, 13, 34, 0.9);
}
.left-menu-tooltip.el-tooltip__popper .popper__arrow::after {
  border-top-color: rgba(0, 13, 34, 0.9);
}
</style>
